"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultProfileImage = void 0;
exports.defaultProfileImage = [
    {
        slug: 'classics-default',
        type: 'letter',
        color: '#B1B500',
        backgroundColor: '#FEFFC9',
    },
];
